// =============================================================================
// Shared UI helpers used across multiple Profile panels.
// Pulled out of Profile.jsx so each panel file can import what it needs.
// =============================================================================

import { C } from "../../lib/theme";
import { Icon } from "../../components/Icon";

export function Field({ label, children }) {
  return (
    <label style={{ display: "block" }}>
      <div style={{ fontSize: 10.5, fontWeight: 800, color: C.muted, textTransform: "uppercase", letterSpacing: 1, marginBottom: 6 }}>{label}</div>
      {children}
    </label>
  );
}

export function SecurityRow({ icon, title, body, tone }) {
  const fg = tone === "red" ? C.red : C.hunter;
  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 12, padding: "4px 0" }}>
      <span style={{ width: 32, height: 32, borderRadius: 10, background: C.cream, display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
        <Icon name={icon} size={14} color={fg} />
      </span>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 13, fontWeight: 800, color: tone === "red" ? C.red : C.charcoal }}>{title}</div>
        <div style={{ fontSize: 12, color: C.muted, marginTop: 2, lineHeight: 1.5 }}>{body}</div>
      </div>
    </div>
  );
}

export function InfoRow({ icon, title, body }) {
  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 12, padding: "4px 0" }}>
      <span style={{ width: 32, height: 32, borderRadius: 10, background: C.cream, display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
        <Icon name={icon} size={14} color={C.hunter} />
      </span>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 12.5, fontWeight: 800, color: C.charcoal }}>{title}</div>
        <div style={{ fontSize: 11.5, color: C.muted, marginTop: 2, lineHeight: 1.5 }}>{body}</div>
      </div>
    </div>
  );
}

export const inputStyle = {
  width:        "100%",
  padding:      "10px 12px",
  border:       "1px solid rgba(196,193,183,0.4)",
  borderRadius: 10,
  fontSize:     13,
  fontFamily:   "inherit",
  color:        C.charcoal,
  background:   C.white,
  outline:      "none",
  boxSizing:    "border-box",
};
